<div class="add-Employee-responsive p-g-12">
   <div class="p-g-12">

      <p-tabView>

         <div class="p-g">

            <div class="p-g-12">
               <form>
                  <div class="p-g-12">
                     <p-toolbar>
                        <div class="p-toolbar-group-left">
                           <button routerLink="/employees-listing" style="background-color: #405569; margin-right: 8px;"
                              class="p-button p-widget p-state-default p-corner-all"><i class="fa fa-arrow-left"
                                 style="margin-right: 8px;"></i>{{setLabel("goBackBtnLabel")}}
                           </button>

                           <button routerLink="/employee" style="background-color: #5192d0; margin-right: 8px;"
                              class="p-button p-widget p-state-default p-corner-all">
                              <i class="fa fa-plus" style="margin-right: 8px;"></i>
                              {{setLabel("newBtnLabel")}}
                              <span style="font-family: none;font-size: small;"> (F2)</span>
                           </button>

                           <button id="saveButton" style="background: #4CAF50; color: white; margin-right: 8px;"
                              [disabled]="(!addEditEmployeeForm.valid || Employee.designation == 0)"
                              class="p-button p-widget p-state-default p-corner-all" (click)="save()"
                              *ngIf="mode == 'add'">
                              <i class="fa fa-floppy-o" style="margin-right: 8px;"></i> {{setLabel("saveBtnLabel")}}
                           </button>

                           <button id="updateButton" style="background: #4CAF50; color: white; margin-right: 8px;"
                              [disabled]="(!addEditEmployeeForm.valid || Employee.designation == 0)"
                              class="p-button p-widget p-state-default p-corner-all" (click)="update()"
                              *ngIf="mode == 'edit'">
                              <i class="fa fa-floppy-o" style="margin-right: 8px;"></i> {{setLabel("updateBtnLabel")}}
                           </button>

                           <button id="updateButton" style="background: #8b3989; color: white; margin-right: 8px;"
                              class="p-button p-widget p-state-default p-corner-all" (click)="viewEmployeeUser()"
                              *ngIf="mode == 'edit' && Employee.userId != undefined">
                              <i class="fa fa-user" style="margin-right: 8px;"></i> {{setLabel("viewUserBtnLabel")}}
                           </button>

                           <button id="updateButton" style="background: #ad7000; color: white; margin-right: 8px;"
                              class="p-button p-widget p-state-default p-corner-all" (click)="viewEmployeeTrainer()"
                              *ngIf="mode == 'edit' && Employee.trainerId != undefined">
                              <i class="fa fa-user" style="margin-right: 8px;"></i> {{setLabel("viewTrainerBtnLabel")}}
                           </button>


                           <button *ngIf="mode == 'edit' && Employee.userId == undefined"
                              style="background: #8b3989; color: white; margin-right: 8px;"
                              (click)="existingUsersDialog = true ; existingTrainersDialog = false; focusUserSearchInput();"
                              class="p-button p-widget p-state-default p-corner-all">
                              <i class="fa fa-plus" style="margin-right: 8px;"></i> {{setLabel("linkWithUserBtnLabel")}}
                           </button>

                           <!-- <button *ngIf="mode == 'edit' && Employee.trainerId == undefined"
                              style="background: #ad7000; color: white; margin-right: 8px;"
                              (click)="existingTrainersDialog = true ; existingUsersDialog = false ; focusTrainerSearchInput();"
                             class="p-button p-widget p-state-default p-corner-all">
                              <i class="fa fa-plus" style="margin-right: 8px;"></i> Link with trainer
                           </button> -->

                           <button *ngIf="mode == 'edit'" [disabled]="!isEnableIssueSalaryButtton"
                              style="background: #eae3e3; color: black; margin-right: 8px;"
                              (click)="showIssueSalaryDialogue()"
                              class="p-button p-widget p-state-default p-corner-all">
                              <i class="fa fa-plus" style="margin-right: 6px;"></i> {{setLabel("issueSalaryBtnLabel")}}
                           </button>

                        </div>
                     </p-toolbar>
                  </div>

                  <p-tabView [activeIndex]="tabIndex" (onChange)="handleTabChange($event)">

                     <p-tabPanel [header]='setLabel("employeeInfoHeaderLabel")'>
                        <div class="card card-w-title">

                           <div class="profileImgContainer">
                              <div class="p-g-4 imgstyle">
                                 <img style="width: 200px; height: 200px" [src]="!uploadProfile
                                 ? Employee.profile
                                 ? config.Server + config.employeeImagePath + Employee.profile
                                 : Employee.gender && Employee.gender == 'F'
                                 ? 'assets/layout/images/avatarGirlImage.png'
                                 : 'assets/layout/images/avatarBoyImage.png'
                                 : Employee.profile
                                 ? Employee.profile
                                 : Employee.gender && Employee.gender == 'F'
                                 ? 'assets/layout/images/avatarGirlImage.png'
                                 : 'assets/layout/images/avatarBoyImage.png'
                                 " onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" />
                              </div>
                              <div class="userDetailToolBar">
                                 <h3 class="first">{{setLabel("profilePictureBtnLabel")}}</h3>
                                 <button (click)="captureImageDialogShow('Cam')" class="">
                                    <span class="p-button-text p-c">
                                       <i class="fa fa-camera" aria-hidden="true"></i> &nbsp;{{setLabel("capturePhotoBtnLabel")}}
                                    </span>
                                 </button>
                                 <button (click)="captureImageDialogShow('Upload')" class="">
                                    <span class="p-button-text p-c">
                                       <i class="fa fa-upload" aria-hidden="true"></i> &nbsp;{{setLabel("uploadPhotoBtnLabel")}}
                                    </span>
                                 </button>
                                 <button (click)="removeProfileImage()" class="removePhoto">
                                    <span class="p-button-text p-c">
                                       <i class="fa fa-times"></i> &nbsp;{{setLabel("removePhotoBtnLabel")}}
                                    </span>
                                 </button>

                              </div>
                           </div>

                           <div class="detail-Main p-g-12">
                              <form class="form-Main" #addEditEmployeeForm="ngForm">

                                 <div class="p-g-12 p-md-6" style="text-align: left">

                                    <div class="p-g p-fluid">

                                       <h3 class="first">{{setLabel("employeeDetailsLabel")}} </h3>

                                       <div class="p-g-12">

                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon" [pTooltip]='setLabel("nameTooltipLabel")' tooltipPosition="top"><i
                                                   class="fa fa-user" aria-hidden="true"></i></span>
                                             <input autocomplete="off" id="employeeName" #employeeName
                                                pattern="[A-Za-z ]+"
                                                [ngClass]="Name.invalid && (Name.dirty || Name.touched) ? 'errorInput' : ''"
                                                type="text" autofocus [placeholder]='setLabel("name*PlaceholderLabel")' #Name="ngModel" name="name"
                                                required [(ngModel)]="Employee.name" />
                                          </div>
                                          <div *ngIf="Name.invalid &&
                                                                         (Name.dirty ||
                                                                         Name.touched)">
                                             <div *ngIf="Name.errors.required" class="errorShow">
                                                {{setLabel("nameRequiredErrorLabel")}}
                                             </div>
                                             <div *ngIf="Name.errors.pattern" class="errorShow">
                                                {{setLabel("charactersAllowedErrorLabel")}}
                                             </div>
                                          </div>

                                       </div>

                                       <div class="p-g-12">
                                          <app-phone-input
                                             id="employeeNumber"
                                             name="contact"
                                             [placeholder]="setLabel('mobile*PlaceholderLabel')"
                                             [(ngModel)]="Employee.phone"
                                             [required]="true">
                                          </app-phone-input>
                                       </div>

                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon" [pTooltip]='setLabel("emailTooltipLabel")' tooltipPosition="top"><i
                                                   class="fa fa-envelope" aria-hidden="true"></i></span>
                                             <input type="email" id="employeeMail" autocomplete="off"
                                             [placeholder]='setLabel("emailPlaceholderLabel")' name="email" #email="ngModel"
                                                [(ngModel)]="Employee.email"
                                                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
                                          </div>
                                          <div *ngIf="email.invalid && (email.dirty || email.touched)">
                                             <div *ngIf="email.errors.required" class="errorShow">
                                                {{setLabel("emailRequiredErorLabel")}}
                                             </div>
                                             <div *ngIf="email.errors.pattern" class="errorShow">
                                                {{setLabel("emailCorrectlyErrorLabel")}}
                                             </div>
                                          </div>
                                       </div>
                                    </div>

                                    <div class="p-g-12">
                                       <div class="p-g">
                                          <h3 class="first">{{setLabel("designationLabel")}} <span style="color: red;">*</span></h3>
                                          <div class="p-g-12">
                                             <div class="p-inputgroup" style="display: flex;">
                                                <span class="p-inputgroup-addon" [pTooltip]='setLabel("designationTooltipLabel")'
                                                   tooltipPosition="top"><i class="fa fa-id-card"
                                                      aria-hidden="true"></i></span>
                                                &nbsp;
                                                <p-dropdown class="dropdownFull" id="designationDd"
                                                   [(ngModel)]="Employee.designation" name="designation"
                                                   [options]="sourceDesignation" [style]="{'width':'100%'}"
                                                   appendTo="body" required="required">
                                                </p-dropdown>
                                             </div>
                                          </div>

                                       </div>
                                    </div>

                                    <div class="p-g-12">
                                       <div class="p-g">
                                          <h3 class="first">{{setLabel("genderLabel")}}</h3>
                                          <div class="p-g-12">
                                             <div class="p-g-6">
                                                <p-radioButton name="group1" id="employeeGender" [value]='setLabel("maleLabel")'
                                                   [label]='setLabel("maleLabel")' (change)="changeProfile()"
                                                   (ngModelChange)="changeProfile()" [(ngModel)]="Employee.gender"
                                                   inputId="opt1"
                                                   [ngClass]="Employee.gender === 'Male' && currentStep == 4 ? 'radioBtnHighlite' : ''">
                                                </p-radioButton>
                                             </div>
                                             <div class="p-g-6">
                                                <p-radioButton name="group1" [value]='setLabel("femaleLabel")' [label]='setLabel("femaleLabel")'
                                                   (change)="changeProfile()" (ngModelChange)="changeProfile()"
                                                   [(ngModel)]="Employee.gender" inputId="opt2"
                                                   [ngClass]="Employee.gender === 'Female' && currentStep == 4 ? 'radioBtnHighlite' : ''">
                                                </p-radioButton>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>

                                 <div class="p-g-12 p-md-6" style="text-align: left">
                                    <h3 class="first">{{setLabel("joiningDateLabel")}}</h3>
                                    <div class="p-g p-fluid">
                                       <div class="p-g-12">
                                          <p-calendar [yearNavigator]="true" yearRange="1950:2040"
                                             [monthNavigator]="true" [(ngModel)]="Employee.createdDate"
                                             [placeholder]='setLabel("joiningDatePlaceholderLabel")' [disabled]="true" name="joinDate"
                                             [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                                          </p-calendar>
                                       </div>
                                    </div>

                                    <h3 class="first">{{setLabel("addressLabel")}} <span style="color: red;">*</span></h3>
                                    <div class="p-g p-fluid">
                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon" [pTooltip]='setLabel("streetTooltipLabel")' tooltipPosition="top"><i
                                                   class="fa fa-location-arrow" aria-hidden="true"></i></span>
                                             <input type="text" id="employeeStreet" autocomplete="off"
                                             [placeholder]='setLabel("streetPlaceholderLabel")' name="street" [(ngModel)]="Employee.address.street"
                                                [ngClass]="Street.invalid && (Street.dirty || Street.touched) ? 'errorInput' : ''"
                                                #Street="ngModel" required>

                                          </div>
                                       </div>
                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon" [pTooltip]='setLabel("cityTooltipLabel")' tooltipPosition="top"><i
                                                   class="fa fa-map-marker" aria-hidden="true"></i></span>
                                             <input type="text" id="employeeCity" autocomplete="off" [placeholder]='setLabel("cityPlaceholderLabel")'
                                                name="city" [(ngModel)]="Employee.address.city"
                                                [ngClass]="City.invalid && (City.dirty || City.touched) ? 'errorInput' : ''"
                                                #City="ngModel" required>
                                          </div>
                                       </div>
                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon" [pTooltip]='setLabel("countryTooltipLabel")'
                                                tooltipPosition="top"><i class="fa fa-map-pin"
                                                   aria-hidden="true"></i></span>
                                             <input type="text" id="employeeCountry" autocomplete="off"
                                                [placeholder]='setLabel("countryPlaceholderLabel")' name="country"
                                                [(ngModel)]="Employee.address.country"
                                                [ngClass]="Country.invalid && (Country.dirty || Country.touched) ? 'errorInput' : ''"
                                                #Country="ngModel" required>
                                          </div>
                                       </div>
                                    </div>

                                    <h3 class="first">{{setLabel("commentLabel")}}</h3>
                                    <div class="p-g p-fluid">
                                       <div class="p-g-12">
                                          <div class="p-inputgroup">
                                             <span class="p-inputgroup-addon" [pTooltip]='setLabel("commentTooltipLabel")'
                                                tooltipPosition="top"><i class="fa fa-pencil-square-o"
                                                   aria-hidden="true"></i></span>
                                             <div style="flex-grow: 1;">
                                                <textarea rows="6" id="employeeComment" cols="67" name="comment"
                                                   [(ngModel)]="Employee.comments" [placeholder]='setLabel("commentPlaceholderLabel")'></textarea>
                                                <p style="margin-top: 0px; font-size: smaller; font-family: inherit;">
                                                   {{setLabel("pressLabel")}} &nbsp;<span
                                                      style="font-weight: bold; font-family: monospace;">[placeholder]='setLabel("SHift+EnterLabel")'</span>&nbsp;{{setLabel("toGoToNextLineLabel")}}
                                                </p>
                                             </div>

                                          </div>

                                       </div>
                                    </div>

                                 </div>
                              </form>
                           </div>
                           <div style="clear: both;"></div>
                        </div>
                     </p-tabPanel>

                     <p-tabPanel [header]='setLabel("payHistoryHeaderLabel")' *ngIf="mode == 'edit'">
                        <div class="p-g">
                           <div class="p-g-12">
                              <p-table #dt [value]="Employee.payDetails" [paginator]="true" [rows]="10"
                                 [responsive]="true" [loading]="loading">
                                 <ng-template pTemplate="header">
                                    <tr>
                                       <th style="max-width: 90px; text-align: center;">{{setLabel("salaryMonthLabel")}}</th>
                                       <th style="max-width: 90px; text-align: center;">{{setLabel("issueDateLabel")}}</th>
                                       <th style="max-width: 90px; text-align: center;">{{setLabel("issuedSalaryLabel")}}</th>
                                       <th style="max-width: 90px; text-align: center;">{{setLabel("commentsLabel")}}</th>
                                       <th style="text-align: center;">{{setLabel("actionsLabel")}}</th>
                                    </tr>
                                 </ng-template>
                                 <ng-template pTemplate="body" let-rowData>
                                    <tr>
                                       <td style="text-align: center;">{{getMonth(rowData.month)}} - {{rowData.year}}
                                       </td>
                                       <td style="text-align: center;">{{rowData.date | date: 'medium'}}</td>
                                       <td style="text-align: center;">{{rowData.totalPaid}}</td>

                                       <td (click)="ShowCommentBox(rowData)"
                                          [ngClass]="rowData.description === undefined ? '' : 'commentSectionHighlight'"
                                          style="text-align: center;">

                                          <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                                             *ngIf="rowData.description !== '' && rowData.description != undefined; else emptyComment">
                                             {{rowData.description}}
                                          </div>

                                          <ng-template #emptyComment><span style="font-family: 'FontAwesome';">{{setLabel("noCommentLabel")}}</span>
                                          </ng-template>

                                       </td>

                                       <td style="text-align: center;">
                                          <button pButton type="button" [pTooltip]='setLabel("deleteTooltipLabel")' tooltipPosition="top"
                                             class="p-button-danger p-button" icon="fa fa-times"
                                             (click)="deleteSalaryRecord(rowData)"></button>
                                       </td>
                                    </tr>
                                 </ng-template>

                                 <ng-template pTemplate="emptymessage" let-columns>
                                    <tr style="color: black;">
                                       <td>
                                          {{setLabel("noRecordsFoundLabel")}}
                                       </td>
                                    </tr>
                                 </ng-template>

                              </p-table>
                           </div>
                        </div>
                     </p-tabPanel>

                  </p-tabView>
               </form>
            </div>
         </div>
      </p-tabView>
   </div>

   <div *ngIf="dialogVisibility">
      <p-dialog [header]='setLabel("addProductImageHeaderLabel")' [(visible)]="dialogVisibility">
         <app-add-profile-image [popupType]="addProfileImage" (closeThePopup)="hideAddProfileImage()"
            (outputImage)="handleImagefromNewProfile($event)"></app-add-profile-image>
      </p-dialog>
   </div>
</div>

<p-dialog [(visible)]="existingUsersDialog" [closeOnEscape]="true" [focusOnShow]="false"
   [style]="{width: '55vw', left:'5%', top:'10px'}">
   <p-header>
      {{setLabel("existingUsersLabel")}}
   </p-header>
   <form>
      <div class="p-g-12 p-table-tecfolk-fix">

         <p-table #dt1 [value]="users" [paginator]="true" [rows]="6" [responsive]="true" [loading]="loading"
            [first]="firstOfUserTable" (onPage)="onPageChangeUsersTable($event)">

            <ng-template pTemplate="caption" style="text-align: left">
               <input
                  style=" color: black ; height:30px ;outline: none; box-shadow: none; margin-right: 8px; width: 20% !important;"
                  id="userSearch" autocomplete="off" pinputtext="" [placeholder]='setLabel("searchByUserNamePlaceholderLabel")' type="text"
                  name="name" class="ng-pristine ng-valid ng-touched"
                  (keyup)="searchLocalUsers(userObject.name, 'name')" [(ngModel)]="userObject.name">

               <button style="background: #ffffff; color: #0e2031; margin-right: 8px;" (click)="clearUserSearchField()"
                  class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                     class="fa fa-eraser"></i>&nbsp;{{setLabel("clearSearchBtnLabel")}}
               </button>
            </ng-template>

            <ng-template pTemplate="header">
               <tr>
                  <th style="max-width: 90px;">{{setLabel("nameLabel")}}</th>
                  <th style="max-width: 90px;">{{setLabel("photoLabel")}}</th>
                  <th style="max-width: 130px;">{{setLabel("emailLabel")}}</th>
                  <th style="max-width: 130px; text-align: center;">{{setLabel("actionLabel")}}</th>
               </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
               <tr>
                  <td>{{rowData.name}}</td>
                  <td>
                     <a (click)="openPhoto(rowData.profile)">
                        <img [alt]="" [src]="!uploadProfile
                        ? rowData.profile
                        ? config.Server + config.employeeImagePath + rowData.profile
                        : rowData.gender && rowData.gender == 'F'
                        ? 'assets/layout/images/avatarGirlImage.png'
                        : 'assets/layout/images/avatarBoyImage.png'
                        : rowData.profile
                        ? rowData.profile
                        : rowData.gender && rowData.gender == 'F'
                        ? 'assets/layout/images/avatarGirlImage.png'
                        : 'assets/layout/images/avatarBoyImage.png'
                        " onerror="this.src = 'assets/layout/images/avatarBoyImage.png'" width="60"
                           style="vertical-align: middle" />
                     </a>
                  </td>
                  <td>{{rowData.email}}</td>
                  <td style="text-align: center;">
                     <button pButton type="button" [pTooltip]='setLabel("linkwithcurrentEmployeeTooltipLabel")' tooltipPosition="top"
                        icon="fa fa-link" style="margin-right: 5px;" (click)="linkUserWithEmployee(rowData)">
                     </button>
                  </td>
               </tr>
            </ng-template>

         </p-table>

      </div>
   </form>
</p-dialog>

<p-dialog [(visible)]="existingTrainersDialog" [closeOnEscape]="true" [focusOnShow]="false"
   [style]="{width: '55vw', left:'448px', top:'23px'}">
   <p-header>
      {{setLabel("existingTrainersLabel")}}
   </p-header>
   <form>
      <div class="p-g-12">

         <p-table #dt2 [value]="trainers" [paginator]="true" [rows]="6" [responsive]="true" [loading]="loading"
            [first]="firstOfTrainerTable" (onPage)="onPageChangeTrainersTable($event)">

            <ng-template pTemplate="caption" style="text-align: left">
               <input
                  style=" color: black ; height:30px ;outline: none; box-shadow: none; margin-right: 8px; width: 20% !important;"
                  id="trainerSearch" autocomplete="off" pinputtext="" [placeholder]='setLabel("searchByUserNamePlaceholderLabel")' type="text"
                  name="name" class="ng-pristine ng-valid ng-touched"
                  (keyup)="searchLocalTrainers(trainer.name, 'name')" [(ngModel)]="trainer.name">

               <button style="background: #ffffff; color: #0e2031; margin-right: 8px;"
                  (click)="clearTrainersSearchField()"
                  class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                     class="fa fa-eraser"></i>&nbsp;Clear Search
               </button>
            </ng-template>


            <ng-template pTemplate="header">
               <tr>
                  <th style="max-width: 90px;">{{setLabel("nameLabel")}}</th>
                  <th style="max-width: 90px;">{{setLabel("photoLabel")}}</th>
                  <th style="max-width: 130px;">{{setLabel("phoneLabel")}}</th>
                  <th style="max-width: 130px; text-align: center;">{{setLabel("actionLabel")}}</th>
               </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
               <tr>
                  <td>{{rowData.name}}</td>
                  <td>
                     <a (click)="openPhoto(rowData.profile)">
                        <img [alt]=""
                           src="{{rowData.profile == null || rowData.profile == '' ? 'assets/layout/images/avatarImg.png' : rowData.profile}}"
                           width="60" style="vertical-align: middle" />
                     </a>
                  </td>
                  <td>{{rowData.contact}}</td>
                  <td style="text-align: center;">
                     <button pButton type="button" [pTooltip]='setLabel("linkwithcurrentEmployeeTooltipLabel")' tooltipPosition="top"
                        icon="fa fa-link" style="margin-right: 5px;" (click)="linkTrainerWithEmployee(rowData)">
                     </button>
                  </td>
               </tr>
            </ng-template>

         </p-table>

      </div>
   </form>
</p-dialog>

<p-dialog [header]='setLabel("issueSalaryHeaderLabel")' [(visible)]="issueSalaryDialogVisibility">
   <form #feeForm="ngForm" style="height: 310px; width: 570px;">
      <div class="p-g-12 p-md-12">
         <div style="display: flex; justify-content: space-around;">

            <p-dropdown [options]="months" name="months" [style]="{'width':'100%'}" [(ngModel)]="currentMonth"
               (onChange)="onChangeMonthDropDown()">
            </p-dropdown>

            <p-dropdown [options]="years" name="year" [style]="{'width':'100%'}" [(ngModel)]="currentYear"
               (onChange)="onChangeYearDropDown()">
            </p-dropdown>

         </div>
      </div>

      <div class="p-g-12 p-md-12" style="padding-top: 15px;">
         <div class="p-inputgroup">
            <span class="p-inputgroup-addon" style=" width: 33%;">{{setLabel("salaryLabel")}} </span>
            <input type="number" [(ngModel)]="pay.salary" style="width: 100% !important;" required pattern="[0-9]+"
               autocomplete="off" [placeholder]='setLabel("salaryPlaceholderLabel")' name="salary" #salary="ngModel" (keyup)="onSalaryFieldChange()"
               [ngClass]="salary.invalid && (salary.dirty || salary.touched) ? 'errorInput' : '' ">
            <span class="p-inputgroup-addon">.00</span>
         </div>
         <div class="p-inputgroup" *ngIf="salary.invalid && (salary.dirty || salary.touched)">
            <span class="p-inputgroup-addon" style=" width: 23%;"></span>

            <div *ngIf="salary.errors.required" class="errorShow" style="width: 100%;">
              {{setLabel("salaryCorrectlyErrorLabel")}}
            </div>
            <div *ngIf="salary.errors.pattern" class="errorShow" style="width: 100%;">
               {{setLabel("salaryCorrectlyErrorLabel")}}
            </div>
         </div>
      </div>

      <div class="p-g-12 p-md-12" style="padding-top: 0px;" *ngIf="Employee.trainerId != undefined">
         <div class="p-inputgroup">
            <span class="p-inputgroup-addon" style=" width: 33%;">{{setLabel("trainerShareLabel")}} </span>
            <input type="number" [(ngModel)]="pay.trainerShare" style="width: 100% !important;" required
               pattern="[0-9]+" autocomplete="off" [placeholder]='setLabel("trainerSharePlaceholderLabel")' name="trainerShare"
               #trainerShare="ngModel" (keyup)="onSalaryFieldChange()" min="0"
               [ngClass]="trainerShare.invalid && (trainerShare.dirty || trainerShare.touched) ? 'errorInput' : '' ">
            <span class="p-inputgroup-addon">.00</span>
         </div>
         <div class="p-inputgroup" *ngIf="trainerShare.invalid && (trainerShare.dirty || trainerShare.touched)">
            <span class="p-inputgroup-addon" style=" width: 23%;"></span>
            <div *ngIf="trainerShare.errors.required" class="errorShow" style="width: 100%;">
               {{setLabel("trainerShareCorrectlyErrorLabel")}}
            </div>
            <div *ngIf="trainerShare.errors.pattern" class="errorShow" style="width: 100%;">
              {{setLabel("trainerShareCorrectlyErrorLabel")}}
            </div>
         </div>
      </div>

      <div class="p-g-12 p-md-12" style="padding-top: 0px;" *ngIf="Employee.trainerId != undefined">
         <div class="p-inputgroup">
            <span class="p-inputgroup-addon" style=" width: 33%;">{{setLabel("totalSalaryLabel")}} </span>
            <input type="number" readonly [(ngModel)]="pay.totalPaid" style="width: 100% !important;" required
               pattern="[0-9]+" autocomplete="off" [placeholder]='setLabel("totalSalaryPlaceholderLabel")' name="totalSalary" #totalSalary="ngModel"
               [ngClass]="totalSalary.invalid && (totalSalary.dirty || totalSalary.touched) ? 'errorInput' : '' ">
            <span class="p-inputgroup-addon">.00</span>
         </div>
         <div class="p-inputgroup" *ngIf="totalSalary.invalid && (totalSalary.dirty || totalSalary.touched)">
            <span class="p-inputgroup-addon" style=" width: 23%;"></span>

            <div *ngIf="totalSalary.errors.required" class="errorShow" style="width: 100%;">
               {{setLabel("totalSalaryCorrectlyErrorLabel")}}
            </div>
            <div *ngIf="totalSalary.errors.pattern" class="errorShow" style="width: 100%;">
              {{setLabel("totalSalaryCorrectlyErrorLabel")}}
            </div>
         </div>
      </div>

      <div class="p-g-12 p-md-12">
         <div class="p-inputgroup">
            <span class="p-inputgroup-addon" style="width: 24%;">{{setLabel("commentLabel")}}</span>
            <textarea style="width: 70% !important;" rows="5" cols="50" [(ngModel)]="pay.description"
               name="description"></textarea>
         </div>
      </div>
      <p-footer>
         <div>
            <button [disabled]="!feeForm.valid" (click)="updateEmployeeSalary()" pButton type="button"
            [label]='setLabel("issueSalaryLabel")' icon="pi pi-save" class="p-button-success"
               style="float: right!important; margin-right: 42px !important; margin-top: 17px;">
            </button>
            <br>
            <br>
            <div class="alert alert-danger" style="float: right !important; margin-top: 18px;">
               <p-message severity="error" text="Salary already issued for this month" *ngIf="salaryAlreadyPaid">
               </p-message>
            </div>

         </div>
      </p-footer>
   </form>
</p-dialog>

<p-dialog [(visible)]="showCommentBox" [closeOnEscape]="true" [focusOnShow]="false"
   [style]="{width: '36vw', left:'570px', top:'288px'}">
   <p-header>
      {{setLabel("salaryCommentLabel")}}
   </p-header>
   <form>
      <div style="height: 140px;">
         <div class="p-g-12">
            <div class="p-inputgroup">
               <span class="p-inputgroup-addon"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>
               <textarea class="textarea" rows="5" readonly cols="80"
                  style="width: 100%; height: 120px; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;"
                  [(ngModel)]="salaryComment" [placeholder]='setLabel("commentPlaceholderLabel")' name="body"></textarea>
            </div>
         </div>
      </div>
   </form>
</p-dialog>

<div id="salaryInvoice" style="display: none;">
   <div class="invoice-box" style="padding: 0px !important;  width: 57mm; max-width: 57mm; margin: 0 !important;">
      <div style="width: 57mm;max-width: 57mm;">
         <img
            [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
            alt="Company Logo" style="
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 58%;
    margin-top: 3px;
    margin-bottom: 2px;
" />
         <div style="
    text-align: center;
    font-size: 11px;
    line-height: 14px;
    color: black;
">
            {{ branch.name }}
         </div>
         <div style="
    text-align: center;
    font-size: 11px;
    line-height: 14px;
    color: black;
">
            {{ branch.address }}
         </div>
         <div style="
    text-align: center;
    font-size: 11px;
    line-height: 15px;
    color: black;
">
            {{ branch.phone }}
         </div>
         <table
            style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">

            <tbody>
               <tr>
                  <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">{{setLabel("salaryInvoice#Label")}}</td>
                  <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;"></td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;font-weight: bold;">{{setLabel("createdLabel")}}</td>
               </tr>
               <tr>
                  <td style="font-size: 10px;text-align: center; padding: 0px;">{{pay.invoice}}</td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;"></td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;">{{pay.date | date:
                     'd/M/yy, h:mm a'}}</td>
               </tr>

            </tbody>
         </table>

         <table
            style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">

            <thead
               style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
               <tr style="background-color: black;color: white; border: 1px solid black;">
                  <th style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("employeeNameLabel")}}</th>
                  <th style="width: 40px;  word-break: break-word; font-size: 10px; ">{{setLabel("salaryMonthLabel")}}</th>
                  <th style="width: 40px;  word-break: break-word; font-size: 10px; ">{{setLabel("issuedSalaryLabel")}}</th>
               </tr>
            </thead>

            <tbody>
               <span>
                  <tr>
                     <td style="font-size: 9px;border:1px solid black;text-align: center;">{{Employee.name}}</td>
                     <td style="font-size: 9px;border:1px solid black;text-align: center;">{{getMonth(pay.month)}}
                        -
                        {{pay.year}}</td>
                     <td style="font-size: 9px;border:1px solid black;text-align: center;">{{pay.totalPaid}}</td>
                  </tr>
               </span>
            </tbody>

         </table>

         <div
            style=" text-align: center;padding-top: 6px; font-size: 10px; font-weight: bold;color: black;white-space: nowrap;">
            {{setLabel("softwareLabel")}}
         </div>

      </div>
   </div>

</div>